import './flagship/style';
import FormStructure from './flagship/form_structure';

export default FormStructure;